import React, { Component } from 'react'
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import SignUp from '../components/Auth/SignUp';
import { Button, Input, Switch, notification } from 'antd';
import { colors, maxScreenSize, spacing } from '../lib/theme';
import PremiumPage from '../components/Common/PremiumPage';
import { dashboardPlanIds, getCurrency, getMonthCount, getMonthCountDisplay, getPrice, premiumDashboardContentQueriesLimit, secToDateDay, serverApiEurope, sleep } from '../lib/utils';
import PremiumPoints from '../components/Premium/PremiumPoints';
import LoadingSpinner from '../components/Common/Loading';
import PremiumCard from '../components/Premium/PremiumCard';
import ClickPremium from '../components/Premium/ClickPremium';
import { tokenFetch } from '../lib/tokenUtils';
import { getGiftCards, getLocationInfoApi, getPremiumInfo, getPremiumInfoData } from '../actions';
import { getDashboardPlanId, getIsPremiumUser } from '../lib/fileUtils';
import { logPremiumOpen } from '../lib/analyticsEvents';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AppCustomLink from '../components/Common/AppCustomLink';

class pricing extends Component {
    constructor(props) {
        super(props);
        this.state = {
            premiumInfo: undefined,
            selectedIndex: 1, // ('initIndex' in props) ? props.initIndex : 2,
            code: '',
            codeApplied: false,
            codeProcessing: false,
            loadingPrices: true,
            isRecurring: false,
            options: [],
            agencyOptions: [],
            billingCycleAnnual: true,
            finalOptions: [],
            errorObj: {},
            email: '',
            success: false,
            successData: {},
            currentCards: []
            // submitting: false
        }
    }

    async componentDidMount() {
        await sleep(500); /// wait for dashboard premium billing to load
        // this.setStripeData();
        this.loadPrices();
        this.loadInitialCode();
        ///let local currencies load.
        this.loadData();
        setTimeout(() => {
            this.setState({})
        }, 700);
        setTimeout(() => {
            logPremiumOpen('premium-offer-app');
        }, 3000);
    }
    async loadData() {
        await getPremiumInfo();
        this.setState({});
        await getLocationInfoApi();
        this.setState({});
    }

    componentDidUpdate(prevProps) {
        const { userDetails } = this.props;
        if (userDetails !== prevProps.userDetails) {
            // this.setStripeData();
        }
    }

    loadInitialCode() {
        const urlParams = new URLSearchParams(window.location.search);
        const codeInUrl = urlParams.get('code');
        if (codeInUrl == 'PODPREMIUM') {
            this.setState({ codeApplied: true, code: 'PODPREMIUM' });
        }
    }

    loadPrices = () => {
        // const { productId } = this.props;
        const currency = 'USD'; // getCurrency();
        // const products = ['prod_P4AUqxboWtjIvu', 'prod_P3mG8PnqX7qWOj', 'prod_P4AZXmF1RgyJcX', 'prod_P3mIKqhDHK0C9x']; // 'prod_Ms7kdACui4gdtg'; // productId || 'prod_MlIhG2xDTbtQm8';
        const products = ['prod_PJTceJ7IGA6tF4', 'prod_PJTj2ljAXHiByD', 'prod_PJTouz7aQUlYee', 'prod_PJTjzEsqu0tNYw', 'prod_PJTinavlzHn7CW']; // 'prod_Ms7kdACui4gdtg'; // productId || 'prod_MlIhG2xDTbtQm8';
        const promises = [];
        for (const product of products) {
            // promises.push(fetch(`${serverApiEurope}stripePricesForCheckout?currency=${currency}&product=${product}`));
            promises.push(fetch(`${serverApiEurope}stripePricesForCheckout?currency=${currency}&product=${product}`));
        }
        Promise.all(promises)
            // fetch(`${serverApiEurope}stripePricesForCheckout?currency=${currency}&product=${product}`)
            .then(async (results) => {
                const { codeApplied } = this.state;
                console.dir(results);
                const resultArray = [];
                // for (const result of results) {
                let options = [];
                let agencyOptions = [];
                for (let i = 0; i < products.length; i++) {
                    const result = results[i];
                    const data = await result.json();
                    const optionsLoc = data['data'] || [];
                    // console.dir(optionsLoc);
                    if (i < 2) {
                        options = [...options, ...optionsLoc];
                    } else {
                        agencyOptions = [...agencyOptions, ...optionsLoc];
                    }
                    // resultArray.push(...optionsLoc);
                }
                console.dir(resultArray);
                const mainOptions = resultArray.filter(el => el.unit_amount > 1100 && el.unit_amount != 4499);
                console.dir(mainOptions);
                const finalOptions = resultArray.filter(el => el.unit_amount == 1039 || el.unit_amount == 4499);
                console.dir(finalOptions);
                this.setState({ loadingPrices: false, options, agencyOptions, finalOptions, isRecurring: false });
            }).catch(err => {
                notification.error({
                    message: 'There was an error loading prices. Please try again.',
                    description: '',
                    duration: null
                });
            })
    }

    applyDiscount = async () => {
        this.setState({ codeProcessing: true });
        await sleep(500);
        const { finalOptions, code } = this.state;
        if (code != 'PODPREMIUM') {
            notification.error({
                message: 'Invalid promo code. Please try again.',
                description: '',
                duration: null
            });
            this.setState({ codeProcessing: false });
            return;
        }
        this.setState({ options: finalOptions, codeProcessing: false, codeApplied: true });
    }

    onChange = (e) => {
        this.setState({ code: e.target.value });
    }
    proceedWithEmail = () => {
        const { email } = this.state;
        if (!email || !email.includes('@')) {
            return;
        }
    }

    choosePremium = (selectedIndex) => {
        this.setState({ selectedIndex });
    }

    origPrice(option) {
        return option.unit_amount == 28800 ? 29 : Math.round(option.unit_amount / 0.8 / 12 / 100);
    }

    optionCard(option, ind) {
        const { billingCycleAnnual } = this.state;
        const { userDetails } = this.props;
        const planId = getDashboardPlanId();
        return (
            <div className='optionCard'>
                <h3>{dashboardPlanIds[ind]['name']}</h3>
                <h4 className='price-div'>{option.unit_amount > 0 && billingCycleAnnual && <s>${this.origPrice(option)}</s>} ${Math.round(option.unit_amount / (billingCycleAnnual ? 12 : 1) / 100)}
                    &nbsp; &nbsp;{option.unit_amount > 0 && billingCycleAnnual && <div className='annual'>${option.unit_amount / 100} Billed Annually</div>}
                </h4>

                <div>
                    <p><FontAwesomeIcon style={{ color: 'green' }} icon={'check'} />&nbsp; {dashboardPlanIds[ind]['mins']} mins Transcript AI</p>
                    <p><FontAwesomeIcon style={{ color: 'green' }} icon={'check'} />&nbsp; {ind > 1 ? 'Unlimited Content Generation' : `${premiumDashboardContentQueriesLimit} content queries/day`}</p>
                    <p><FontAwesomeIcon style={{ color: 'green' }} icon={'check'} />&nbsp; Unlimited Link Trackers</p>
                    <AppCustomLink href={'/ads'}>
                        <a target='_blank'>
                            <p><FontAwesomeIcon style={{ color: dashboardPlanIds[ind]['adDiscount'] > 0 ? 'green' : 'red' }} icon={dashboardPlanIds[ind]['adDiscount'] > 0 ? 'check' : 'times'} />&nbsp; {dashboardPlanIds[ind]['adDiscount'] > 0 ?
                                `Extra ${dashboardPlanIds[ind]['adDiscount']}% Off Ad slot` : 'No Ad slot discount'} <FontAwesomeIcon icon='external-link-alt' size='sm' /></p>
                        </a>
                    </AppCustomLink>
                </div>
                {/* {userDetails && userDetails.uid && planId == ind && <div className='current'><h4 className='mb-0'>Current Plan</h4></div>} */}
                {(option.unit_amount && planId != ind) ? <div>
                    <ClickPremium isOffer={false} option={option} type='dashboard' />
                </div> : <div><br /></div>
                }
                <style>
                    {`
                    .current {
                        padding: 8px 12px;
                        border-radius: 12px;
                        background: #FF6D00;
                        display: inline-block;
                    }
                    .current h4 {
                        color: white !important;
                    }
                    .optionCard {
                        background: white;
                        border-radius: 12px;
                        padding: 16px;
                        margin: 16px;
                    }
                    .annual {
                        background: ${colors.primary};
                        color: white;
                        border-radius: 8px;
                        padding: 4px 8px;
                        font-size: 12px;
                        display: inline-block;
                        // margin-bottom: 16px;
                    }
                    .price-div {
                        margin-bottom: 16px;
                    }
                    @media ${maxScreenSize.tablet} {
                        .optionCard {
                            margin: 16px 4px;
                        }
                    }
                    }
                    `}
                </style>
            </div>
        )
    }
    filterOptions = (options) => {
        const { billingCycleAnnual } = this.state;
        if (billingCycleAnnual) {
            return options.filter(el => el?.recurring?.interval == 'year').sort((el1, el2) => el1.unit_amount - el2.unit_amount);
        } else {
            return options.filter(el => el?.recurring?.interval == 'month').sort((el1, el2) => el1.unit_amount - el2.unit_amount);
        }
    }

    render() {
        if (!process.browser) {
            return <></>
        }
        const urlParams = new URLSearchParams(window.location.search);
        const emailInUrl = urlParams.get('email');
        const codeInUrl = urlParams.get('code');
        const { userDetails, settingsState } = this.props;
        const { selectedIndex, loadingPrices, options, agencyOptions, billingCycleAnnual,
            success, successData, currentCards, code, codeProcessing, codeApplied } = this.state;
        const signedIn = userDetails && userDetails.uid;
        const premiumInfoLoc = getPremiumInfoData() || {};
        console.dir(options);
        console.dir(billingCycleAnnual);
        return (
            <div>
                {/* {signedIn && <div>
                    <h3>Gift Cards</h3>
                </div>} */}
                <div>
                    {true && <h1 className='text-center'>🚀 Podcaster Tools</h1>}
                    {/* <div className='text-center'>Podcast player for iOS, Android, Web, macOS and Windows10</div> */}
                    <br />
                    <div className='text-center'>
                        Monthly&nbsp;&nbsp;
                        <Switch checked={billingCycleAnnual} onChange={(e) => { this.setState({ billingCycleAnnual: e }) }} />&nbsp;&nbsp;
                        Annual (Save 20&#37;)
                    </div>
                    <br />

                    {loadingPrices ? <div><LoadingSpinner /> </div> : <div>
                        <div className='card-div'>
                            {[{ unit_amount: 0 }, ...this.filterOptions(options)].map((option, index) => (
                                <div key={index}>
                                    {this.optionCard(option, index + 1)}
                                    {/* <PremiumCard option={option} index={index} isOffer={true} selectedIndex={selectedIndex}
                                        options={options} discount={codeApplied ? (index == 0 ? 20 : 55) : 1} choosePremium={this.choosePremium} /> */}
                                </div>
                            ))}
                        </div>
                        <div className='card-div'>
                            {this.filterOptions(agencyOptions).map((option, index) => (
                                <div key={index}>
                                    {this.optionCard(option, index + 4)}
                                    {/* <PremiumCard option={option} index={index} isOffer={true} selectedIndex={selectedIndex}
                                        options={options} discount={codeApplied ? (index == 0 ? 20 : 55) : 1} choosePremium={this.choosePremium} /> */}
                                </div>
                            ))}
                        </div>
                        {/* <div className='text-center' style={{ marginBottom: '8px' }}>
                            <ClickPremium isOffer={true} option={options[0]} />
                        </div> */}
                        {/* {options.length > 0 && <div className='text-center'>
                            {getPrice(options[selectedIndex])}&#47;{getMonthCountDisplay(options[selectedIndex], selectedIndex)} {getMonthCount(options[selectedIndex], selectedIndex) > 200 ? '' : 'months'}{!isOffer && <span>, cancel any time</span>}
                        </div>} */}
                    </div>}
                </div>
                {/* {getIsPremiumUser() ? <p className='mt-2'>You are already a premium member.</p> :
                    <div style={{ width: '340px', margin: '2em auto', }}>
                        <Input.Group compact>
                            <Input style={{ width: 'calc(100% - 100px)' }} onChange={this.onChange} defaultValue={codeInUrl || ''} placeholder='Enter offer code' />
                            <Button onClick={this.applyDiscount} type="primary">{codeProcessing ? 'Apply...' : (codeApplied ? 'Applied' : 'Apply')}</Button>
                        </Input.Group>
                    </div>
                } */}
                {/* <div className='text-center'>
                    <ClickPremium isOffer={selectedIndex == 1} option={options[selectedIndex]} type='premiumSocial' />
                </div>
                {options.length > 0 && <div className='text-center mt-2'>
                    {getPrice(options[selectedIndex])}&#47;{getMonthCountDisplay(options[selectedIndex], selectedIndex)} {getMonthCount(options[selectedIndex], selectedIndex) > 200 ? '' : 'months'}{!(selectedIndex == 1) && <span>, cancel any time</span>}
                </div>}
                {selectedIndex == 0 &&
                    <div className='mt-2 text-center'><h5>{(premiumInfoLoc['bottom'] ?? 'Cancel anytime').replace('{appstore}', '')}</h5></div>
                } */}
                <br />
                <style jsx>
                    {`
                        .signin {
                            display: flex;
                            justify-content: center;
                        }
                        .social-text {
                          width: 50%;
                          text-align: center;
                          border-bottom: 1px solid hsla(198, 8%, 32%, 1);
                          line-height: 0.1em;
                        //   margin: ${spacing('xl')} ${spacing('')} 2em ${spacing('')};
                            margin: auto;
                        }
                        .social-text span{
                          background: ${settingsState.mainLayoutColor};
                          padding: 0 10px;
                        }
                        .card-div {
                            display: flex;
                            justify-content: center;
                        }
                        .card-specific-div {
                            background: ${settingsState.cardColor}; // white;
                            border-radius: ${spacing()};
                            padding: 1em 2em;
                            margin-bottom: 1em;
                        }
                        .success-div {
                            text-align: center;
                            background: ${settingsState.cardColor}; // white;
                            border-radius: ${spacing()};
                            padding: 6em 2em;
                        }
                        .code-span {
                            color: green;
                        }
                    `}
                </style>
            </div>
        )
    }
}

pricing.propTypes = {
    // productId: PropTypes.string,
    // initIndex: PropTypes.number,
    // isOffer: PropTypes.bool,
    userDetails: PropTypes.object,
    settingsState: PropTypes.object,
}
const mapStateToProps = (state) => {
    return {
        userDetails: state.userDetails,
        settingsState: state.settingsState,
    }
}
export default connect(mapStateToProps, null)(pricing);